import { Box, Divider, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import useResponsive from '../../../../Hooks/useResponsive';

const ChartSection = ({ totalScore, outOfScore, rating }) => {
  const mdUp = useResponsive('up', 'md');
  const percentage = (totalScore / outOfScore) * 100;

  const Radial = {
    series: [percentage], // used to draw the arc
    options: {
      chart: { type: 'radialBar', sparkline: { enabled: true } },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: '#e7e7e7',
            strokeWidth: '97%',
            margin: 5,
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: '#444',
              opacity: 1,
              blur: 2,
            },
          },
          dataLabels: {
            name: { show: false },
            value: {
              offsetY: 0,
              fontSize: '24px',
              fontWeight: 'bold',
              formatter: () => `${totalScore} / ${outOfScore}`, // display actual score
            },
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          shadeIntensity: 0.4,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 53, 91],
        },
      },
      labels: ['Final Score'],
    },
  };

  return (
    <Box>
      <>
        <Box
          mt={2}
          sx={{
            height: '150px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <ReactApexChart options={Radial?.options} series={Radial?.series} type="radialBar" height="120%" />
          
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 'bold',
              color: '#333',
              letterSpacing: '0.5px',
              position: 'relative',
              top: -70,
            }}
          >
            Performance Overview
          </Typography>
          <Typography
          textTransform={'capitalize'}
            variant="caption"
            sx={{
              fontWeight: 'bold',
              color: ' #38a7fc',
              letterSpacing: '0.5px',
              position: 'relative',
              top: -70,
            }}
          >
            {rating}
          </Typography>
        </Box>
      </>
    </Box>
  );
};

export default React.memo(ChartSection);
